"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

class MTableGroupRow extends React.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "rotateIconStyle", isOpen => ({
      transform: isOpen ? "rotate(90deg)" : "none"
    }));
  }
  render() {
    let colSpan = this.props.columns.filter(columnDef => !columnDef.hidden).length;
    this.props.options.selection && colSpan++;
    this.props.detailPanel && colSpan++;
    this.props.actions && this.props.actions.length > 0 && colSpan++;
    const column = this.props.groups[this.props.level];
    let detail;
    if (this.props.groupData.isExpanded) {
      if (this.props.groups.length > this.props.level + 1) {
        // Is there another group
        detail = this.props.groupData.groups.map((groupData, index) => /*#__PURE__*/React.createElement(this.props.components.GroupRow, {
          actions: this.props.actions,
          key: groupData.value || "" + index,
          columns: this.props.columns,
          components: this.props.components,
          detailPanel: this.props.detailPanel,
          getFieldValue: this.props.getFieldValue,
          groupData: groupData,
          groups: this.props.groups,
          icons: this.props.icons,
          level: this.props.level + 1,
          path: [...this.props.path, index],
          onGroupExpandChanged: this.props.onGroupExpandChanged,
          onRowSelected: this.props.onRowSelected,
          onRowClick: this.props.onRowClick,
          onToggleDetailPanel: this.props.onToggleDetailPanel,
          onTreeExpandChanged: this.props.onTreeExpandChanged,
          onEditingCanceled: this.props.onEditingCanceled,
          onEditingApproved: this.props.onEditingApproved,
          options: this.props.options,
          hasAnyEditingRow: this.props.hasAnyEditingRow,
          isTreeData: this.props.isTreeData,
          cellEditable: this.props.cellEditable,
          onCellEditStarted: this.props.onCellEditStarted,
          onCellEditFinished: this.props.onCellEditFinished,
          scrollWidth: this.props.scrollWidth
        }));
      } else {
        detail = this.props.groupData.data.map((rowData, index) => {
          if (rowData.tableData.editing) {
            return /*#__PURE__*/React.createElement(this.props.components.EditRow, {
              columns: this.props.columns,
              components: this.props.components,
              data: rowData,
              icons: this.props.icons,
              path: [...this.props.path, index],
              localization: this.props.localization,
              key: index,
              mode: rowData.tableData.editing,
              options: this.props.options,
              isTreeData: this.props.isTreeData,
              detailPanel: this.props.detailPanel,
              onEditingCanceled: this.props.onEditingCanceled,
              onEditingApproved: this.props.onEditingApproved,
              getFieldValue: this.props.getFieldValue,
              onBulkEditRowChanged: this.props.onBulkEditRowChanged,
              scrollWidth: this.props.scrollWidth
            });
          } else {
            return /*#__PURE__*/React.createElement(this.props.components.Row, {
              actions: this.props.actions,
              key: index,
              columns: this.props.columns,
              components: this.props.components,
              data: rowData,
              detailPanel: this.props.detailPanel,
              getFieldValue: this.props.getFieldValue,
              icons: this.props.icons,
              path: [...this.props.path, index],
              onRowSelected: this.props.onRowSelected,
              onRowClick: this.props.onRowClick,
              onToggleDetailPanel: this.props.onToggleDetailPanel,
              options: this.props.options,
              isTreeData: this.props.isTreeData,
              onTreeExpandChanged: this.props.onTreeExpandChanged,
              onEditingCanceled: this.props.onEditingCanceled,
              onEditingApproved: this.props.onEditingApproved,
              hasAnyEditingRow: this.props.hasAnyEditingRow,
              cellEditable: this.props.cellEditable,
              onCellEditStarted: this.props.onCellEditStarted,
              onCellEditFinished: this.props.onCellEditFinished,
              scrollWidth: this.props.scrollWidth
            });
          }
        });
      }
    }
    const freeCells = [];
    for (let i = 0; i < this.props.level; i++) {
      freeCells.push( /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "checkbox",
        key: i
      }));
    }
    let value = this.props.groupData.value;
    if (column.lookup) {
      value = column.lookup[value];
    }
    let title = column.title;
    if (typeof this.props.options.groupTitle === "function") {
      title = this.props.options.groupTitle(this.props.groupData);
    } else if (typeof title !== "string") {
      title = React.cloneElement(title);
    }
    let separator = this.props.options.groupRowSeparator || ": ";
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_TableRow.default, null, freeCells, /*#__PURE__*/React.createElement(this.props.components.Cell, {
      colSpan: colSpan,
      padding: "none",
      columnDef: column,
      value: value,
      icons: this.props.icons
    }, /*#__PURE__*/React.createElement(_IconButton.default, {
      style: (0, _objectSpread2.default)({
        transition: "all ease 200ms"
      }, this.rotateIconStyle(this.props.groupData.isExpanded)),
      onClick: event => {
        this.props.onGroupExpandChanged(this.props.path);
      }
    }, /*#__PURE__*/React.createElement(this.props.icons.DetailPanel, null)), /*#__PURE__*/React.createElement("b", null, title, separator))), detail);
  }
}
exports.default = MTableGroupRow;
MTableGroupRow.defaultProps = {
  columns: [],
  groups: [],
  options: {},
  level: 0
};
MTableGroupRow.propTypes = {
  actions: _propTypes.default.array,
  columns: _propTypes.default.arrayOf(_propTypes.default.object),
  components: _propTypes.default.object,
  detailPanel: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.arrayOf(_propTypes.default.object)]),
  getFieldValue: _propTypes.default.func,
  groupData: _propTypes.default.object,
  groups: _propTypes.default.arrayOf(_propTypes.default.object),
  hasAnyEditingRow: _propTypes.default.bool,
  icons: _propTypes.default.object,
  isTreeData: _propTypes.default.bool.isRequired,
  level: _propTypes.default.number,
  localization: _propTypes.default.object,
  onGroupExpandChanged: _propTypes.default.func,
  onRowSelected: _propTypes.default.func,
  onRowClick: _propTypes.default.func,
  onToggleDetailPanel: _propTypes.default.func.isRequired,
  onTreeExpandChanged: _propTypes.default.func.isRequired,
  onEditingCanceled: _propTypes.default.func,
  onEditingApproved: _propTypes.default.func,
  options: _propTypes.default.object,
  path: _propTypes.default.arrayOf(_propTypes.default.number),
  scrollWidth: _propTypes.default.number.isRequired,
  cellEditable: _propTypes.default.object,
  onCellEditStarted: _propTypes.default.func,
  onCellEditFinished: _propTypes.default.func,
  onBulkEditRowChanged: _propTypes.default.func
};